import React from "react";

const ForTeamPage = () => {
  return <div>ForTeamPage</div>;
};

export default ForTeamPage;
